import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Login } from './pages/Login';
import { ResetPassword } from './pages/ResetPassword';
import { Admin } from './pages/Admin';
import { TenantSettings } from './pages/TenantSettings';
import { Onboarding } from './pages/Onboarding';
import { ProtectedRoute } from './components/ProtectedRoute';
import { OrdersBoard } from './features/orders/OrdersBoard';
import { AddOrderSheet } from './features/orders/AddOrderSheet';
import { ProductsStatus } from './features/products/ProductsStatus';
import { ManageProducts } from './features/products/ManageProducts';
import { HistoryView } from './features/history/HistoryView';
import { RecurringOrdersPage } from './features/recurring/RecurringOrdersPage';
import { TabNav } from './components/TabNav';
import { TopBar } from './components/TopBar';
import { OfflineIndicator, TooltipProvider } from '@paulownia/shared';
import { useAppUpdate } from './hooks/useAppUpdate';

export default function App() {
  const location = useLocation();
  const isSpecialPage = ['/login', '/reset-password', '/admin', '/settings', '/onboarding'].includes(location.pathname);

  // Check for app updates
  useAppUpdate();

  return (
    <TooltipProvider>
      <div className="min-h-screen bg-gray-50">
        {!isSpecialPage && <TopBar />}
        <div className={!isSpecialPage ? 'pt-14' : ''}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />

            {/* Onboarding route - allows access during onboarding flow */}
            <Route element={<ProtectedRoute allowDuringOnboarding />}>
              <Route path="/onboarding" element={<Onboarding />} />
            </Route>

            {/* Main app routes - requires completed onboarding */}
            <Route element={<ProtectedRoute />}>
              <Route path="/dashboard" element={<OrdersBoard />} />
              <Route path="/dashboard/new" element={<AddOrderSheet />} />
              <Route path="/products/status" element={<ProductsStatus />} />
              <Route path="/products/manage" element={<ManageProducts />} />
              <Route path="/history" element={<HistoryView />} />
              <Route path="/recurring" element={<RecurringOrdersPage />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/settings" element={<TenantSettings />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
        {!isSpecialPage && <TabNav />}
        <OfflineIndicator />
      </div>
    </TooltipProvider>
  );
}
